// Is a newer build deployed than the one running? The installed app can stay open for days (iOS keeps it in memory
// and only resumes it), so it would keep running the old build until it is closed for real. It compares its own
// build id (vue.config.js) with the deployed /version.json instead, and UpdatePrompt offers "Uppdatera nu".

/** How often a visible app checks, and the least time between two checks (resume, focus and the timer can coincide). */
export const CHECK_EVERY_MS = 30 * 60 * 1000;
export const MIN_GAP_MS = 60 * 1000;

/** The deployed build's id, or null when it cannot be read (offline, dev server, an old deploy without the file). */
export async function fetchDeployedVersion(fetchImpl = null, now = Date.now()) {
    try {
        const response = await (fetchImpl || fetch)(`/version.json?t=${now}`, { cache: "no-store" });
        if (!response.ok)
            return null;
        const body = await response.json();
        return body && typeof body.version === "string" && body.version ? body.version : null;
    }
    catch {
        return null;
    }
}

/** A different deployed id means a new deploy (a rollback too: reloading gets the deployed one). */
export function isUpdate(current, deployed) {
    return !!current && !!deployed && deployed !== current;
}
